import { notify, parseErrorList } from "../components/utiles";
import { useState } from "react";
import { ALLOWED_EXTENSIONS_DOC } from "../support/Constants";

const apiUrl = process.env.REACT_APP_SINCRONIA_BACKEND_URL;

export const useDocuments = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(null);

  const uploadFiles = async (files) => {
    setIsUploading(true);
    setError(null);

    try {
      const responses = [];
      for (const file of files) {
        if (file instanceof File) {
          const formData = new FormData();
          formData.append("filename", file.name);
          formData.append("file", file, file.name);

          const response = await fetch(`${apiUrl}/storage/file`, {
            method: "POST",
            body: formData,
          });

          if (!response.ok) {
            const message = `
              No se pudo subir el archivo "${file.name}".

              El formato del archivo no está permitido o el tamaño excede el límite de 330MB.

              ${ALLOWED_EXTENSIONS_DOC}
              `;

            notify(message, "error");
            setError(message);
            continue;
          }

          const responseData = await response.json();
          responses.push(responseData);
        }
      }

      if (responses.length > 0) {
        notify("Los documentos fueron agregados con éxito", "success");
      }

      return responses;
    } catch (error) {
      const message = parseErrorList(error);
      notify(message, "error");
      console.error("Error uploading documents:", error);
      setError(
        message ||
          error.message ||
          "An error occurred while uploading documents"
      );
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  const deleteDocument = async (documentId) => {
    setIsDeleting(true);
    setError(null);
    try {
      const res = await fetch(`${apiUrl}/storage/file/${documentId}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error(`Failed to delete document ${documentId}`);

      notify("El documento fue eliminado con éxito", "success");
    } catch (e) {
      const msg = parseErrorList?.(e) || e.message || "Delete error";
      setError(msg);
      notify(msg, "error");
      throw e;
    } finally {
      setIsDeleting(false);
    }
  };

  const getFilesBatch = async (ids = []) => {
    if (!ids.length) return [];

    setIsFetching(true);
    setError(null);

    try {
      const query = ids.join(",");
      const response = await fetch(`${apiUrl}/storage/files?ids=${query}`);

      if (!response.ok) {
        throw new Error("Failed to fetch files batch");
      }

      const data = await response.json();
      return data;
    } catch (e) {
      const msg = parseErrorList?.(e) || e.message || "Fetch error";
      setError(msg);
      notify(msg, "error");
      throw e;
    } finally {
      setIsFetching(false);
    }
  };

  return {
    uploadFiles,
    deleteDocument,
    getFilesBatch,
    isUploading,
    isDeleting,
    isFetching,
    error,
  };
};
